import { Link } from "react-router-dom";
import BrandsLogo3D from "../components/BrandsLogo3D";

const BRANDS = [
  {
    name: "Groove Dance Beats",
    status: "Active",
    copy: "HLT's house music event brand for curated club nights, guestlist culture and QR-ticketed experiences.",
    image: "/grove-dance-beats-london-960x720-letterbox.jpg",
  },
  {
    name: "Inner Spark",
    status: "Coming 2026",
    copy: "A premium wellness, creativity and connection concept built around music-led travel moments.",
    image: "/hlt-management-image.png",
  },
  {
    name: "Word Warehouse",
    status: "Coming 2026",
    copy: "Editorial culture, music writing and artist storytelling for the HLT community engine.",
    image: "/sub-brand-image.png",
  },
];

export default function Brands() {
  return (
    <div className="page space-y-8">
      <section className="card overflow-hidden">
        <div className="grid gap-6 md:grid-cols-[1fr,22rem] md:items-center">
          <div>
            <p className="text-xs uppercase tracking-[0.28em] text-brand-500">HLT ecosystem</p>
            <h1 className="mt-3 font-display text-4xl md:text-5xl">Our Brands</h1>
            <p className="mt-3 max-w-2xl text-slate-300">
              Three connected sub-brands built around house music, culture, travel and talent.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/events" className="btn-primary">Explore events</Link>
              <Link to="/roster" className="btn-secondary">View talent</Link>
            </div>
          </div>
          <BrandsLogo3D />
        </div>
      </section>

      <section className="grid gap-4 md:grid-cols-3">
        {BRANDS.map((brand) => (
          <article key={brand.name} className="card overflow-hidden p-0">
            <img src={brand.image} alt={brand.name} className="h-56 w-full object-cover" />
            <div className="p-5">
              <span className="badge bg-brand-600/20 text-slate-100">{brand.status}</span>
              <h2 className="mt-3 text-2xl font-semibold text-white">{brand.name}</h2>
              <p className="mt-2 text-sm text-slate-300">{brand.copy}</p>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
}
